__turbopack_context__.v({
  "slider": "RangeSlider-module-scss-module__jmRM7W__slider",
  "slider_thumb": "RangeSlider-module-scss-module__jmRM7W__slider_thumb",
  "slider_track": "RangeSlider-module-scss-module__jmRM7W__slider_track",
  "slider_track-0": "RangeSlider-module-scss-module__jmRM7W__slider_track-0",
  "slider_track-1": "RangeSlider-module-scss-module__jmRM7W__slider_track-1",
});
